import { useState, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaChevronDown, FaChevronUp, FaRegHeart } from "react-icons/fa";
import {
	MdOutlineFolder,
	MdOutlineMonetizationOn,
	MdOutlineNotifications,
} from "react-icons/md";
import { CgMenuGridR } from "react-icons/cg";

import Avatar from "react-avatar";
import { Badge } from "primereact/badge";
import { Collapse, Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Nav as Navbar, MenuLogoBox, MenuList } from "./styled";

import logo from "../../../assets/img/logo.svg";
import logoIcon from "../../../assets/img/logo-icon.svg";
import menuItems from "./SidebarItems";
import { colors } from "../../../theme/theme";
import UsuarioContext from "../../../context/userContext/context";
import { useNotification } from "../../../hooks/useNotifications";
import { useUpdatesAndNotifications } from "../../../hooks/useUpdatesAndNotifications";

export const Menu = (props: any): JSX.Element => {
	const history = useHistory();
	const { user } = useContext(UsuarioContext);
	const { t: translation } = useTranslation();
	const { notifications } = useNotification();

	const [usernameFormatted, setUsernameFormatted] = useState("");

	/** Notificações não lidas - quando maior que 0, mostra a badge ao lado do item de menu "Notificações" */
	const {notificationList, list} = useUpdatesAndNotifications();

	useEffect(() => {
		list();
	},[])

	useEffect(() => {
		let spliedtUsername = user.name.split(" ");

		setUsernameFormatted(
			spliedtUsername[0] +
				(spliedtUsername[1] ? " " + spliedtUsername[1] : "")
		);
	}, [user]);

	var permissions: any = [
		{
			menus: ["Cursos", "Disciplinas", "Unidades", "Objetos"],
			subMenus: [],
		},
	];

	if (!permissions[0].menus) {
		history.push("/login");
		return <></>;
	}

	return (
		<>
			<Navbar
				show={props.show}
				showUserInfo={props.showUserInfo}
			>
				{/* Logo da DStore */}
				<MenuLogoBox>
					{props.show ? (
						<Link to="/home">
							<img
								src={logo}
								height="50"
								alt="Dstore Logo"
								style={{ margin: "20px" }}
							/>
						</Link>
					) : (
						<Link to="/home">
							<img
								src={logoIcon}
								height="50"
								alt="Dstore Logo"
								style={{ margin: "20px" }}
							/>
						</Link>
					)}
				</MenuLogoBox>

				{/* Lista de itens de menu genéricos */}
				<MenuList
					show={props.show}
					showUserInfo={props.showUserInfo}
				>
					{menuItems.map((item: any, index: number) => (
						<CollapsableListItem
							key={index}
							item={item}
							permissions={permissions}
							isActive={
								"/" + window.location.pathname.split("/")[1] ===
								item.route
									? true
									: false
							}
							iconColor={item.iconColor}
							show={props.show}
						/>
					))}
				</MenuList>

				{user.token ? (
					<>
						{/* Itens para quando um usuário estiver logado, mas for visitante */}
						{user.profile_status === "Visitante" &&
							!user.is_superuser && (
								<div className="menu-visitor-items-wrapper">
									<OverlayTrigger
										placement={"right"}
										overlay={
											props.show ? (
												<></>
											) : (
												<Tooltip
													id={`tooltip-favorites`}
												>
													{translation(
														"components.menu.plans"
													)}
												</Tooltip>
											)
										}
									>
										<Nav
											className="flex-column p-2 menu-item-plans"
											onClick={() =>
												history.push("/plans")
											}
										>
											<Nav.Item
												className={`d-flex align-items-center hoverMenuPlans ${
													!props.show
														? "justify-content-center"
														: ""
												}`}
											>
												<span className="d-flex mx-3">
													<MdOutlineMonetizationOn
														style={{
															fontSize: "27px",
														}}
													/>
												</span>{" "}
												{props.show
													? translation(
															"components.menu.plans"
													  )
													: ""}
											</Nav.Item>
										</Nav>
									</OverlayTrigger>

									<OverlayTrigger
										placement={"right"}
										overlay={
											props.show ? (
												<></>
											) : (
												<Tooltip
													id={`tooltip-favorites`}
												>
													{translation(
														"components.menu.favorites"
													)}
												</Tooltip>
											)
										}
									>
										<Nav
											className="flex-column p-2 menu-item-favorites"
											data-testid="favoriteItemMenu"
											onClick={() =>
												history.push("/favorites")
											}
										>
											<Nav.Item
												className={`d-flex align-items-center ${
													!props.show
														? "justify-content-center"
														: ""
												} ${
													window.location.pathname ===
													"/materials"
														? "active-user"
														: "hoverMenu"
												}`}
											>
												<span className="d-flex mx-3">
													<FaRegHeart
														className="p-overlay-badge"
														style={{ fontSize: 26 }}
													>
														{!!notifications.quantity && (
															<Badge severity="success"></Badge>
														)}
													</FaRegHeart>
												</span>{" "}
												{props.show
													? translation(
															"components.menu.favorites"
													  )
													: ""}
											</Nav.Item>
										</Nav>
									</OverlayTrigger>
								</div>
							)}

						{/* Itens para um usuário autenticado, que não é visitante */}
						{(user.profile_status !== "Visitante" ||
							user.is_superuser) && (
							<div className="menu-partner-items-wrapper">
								{/* Notificações */}
								<OverlayTrigger
									placement={"right"}
									overlay={
										props.show ? (
											<></>
										) : (
											<Tooltip
												id={`tooltip-notifications`}
											>
												{translation(
													"components.menu.notifications"
												)}
											</Tooltip>
										)
									}
								>
									<Nav
										className="flex-column p-2 menu-item-notifications"
										onClick={() =>
											props.showNotifications
												? props.setShowNotifications(
														false
												  )
												: props.setShowNotifications(
														true
												  )
										}
									>
										<Nav.Item
											className={`d-flex align-items-center ${
												!props.show
													? "justify-content-center"
													: ""
											}${
												props.showNotifications
													? " active-user"
													: " hoverMenu"
											}`}
										>
											<span
												className="d-flex mx-3"
												style={{ position: "relative" }}
											>
												<MdOutlineNotifications
													className="p-overlay-badge"
													style={{ fontSize: 26 }}
												/>

												{notificationList.length > 0 &&
													!props.show && (
														<Badge
															className="notification-badge collapsed"
															severity="danger"
															value={
																notificationList.length
															}
														/>
													)}
											</span>{" "}
											{props.show ? (
												<div className="notification-wrapper">
													<span>
														{translation(
															"components.menu.notifications"
														)}
													</span>

													{notificationList.length >
														0 && (
														<Badge
															className="notification-badge"
															severity="danger"
															value={
																notificationList.length
															}
														/>
													)}
												</div>
											) : (
												""
											)}
										</Nav.Item>
									</Nav>
								</OverlayTrigger>

								{/* Meus materiais */}
								<OverlayTrigger
									placement={"right"}
									overlay={
										props.show ? (
											<></>
										) : (
											<Tooltip id={`tooltip-favorites`}>
												{translation(
													"components.menu.myMaterials"
												)}
											</Tooltip>
										)
									}
								>
									<Nav
										className="flex-column p-2"
										data-testid="favoriteItemMenu"
										onClick={() =>
											history.push("/materials")
										}
									>
										<Nav.Item
											className={`d-flex align-items-center ${
												!props.show
													? "justify-content-center"
													: ""
											} ${
												window.location.pathname ===
												"/materials"
													? "active-user"
													: "hoverMenu"
											}`}
										>
											<span
												className="d-flex mx-3"
												style={{ position: "relative" }}
											>
												<MdOutlineFolder
													className="p-overlay-badge"
													style={{ fontSize: 26 }}
												/>
												{!!notifications.quantity && (
													<Badge
														style={{
															position:
																"absolute",
															left: "80%",
														}}
														severity="success"
													></Badge>
												)}
											</span>{" "}
											{props.show
												? translation(
														"components.menu.myMaterials"
												  )
												: ""}
										</Nav.Item>
									</Nav>
								</OverlayTrigger>

								{/* Favoritos */}
								<OverlayTrigger
									placement={"right"}
									overlay={
										props.show ? (
											<></>
										) : (
											<Tooltip id={`tooltip-favorites`}>
												{translation(
													"components.menu.favorites"
												)}
											</Tooltip>
										)
									}
								>
									<Nav
										className="flex-column p-2 menu-item-favorites"
										data-testid="favoriteItemMenu"
										onClick={() =>
											history.push("/favorites")
										}
									>
										<Nav.Item
											className={`d-flex align-items-center ${
												!props.show
													? "justify-content-center"
													: ""
											} ${
												window.location.pathname ===
												"/favorites"
													? "active-user"
													: "hoverMenu"
											}`}
										>
											<span className="d-flex mx-3">
												<FaRegHeart
													className="p-overlay-badge"
													style={{
														fontSize: 23,
														margin: "0 2px",
													}}
												>
													{!!notifications.quantity && (
														<Badge severity="success"></Badge>
													)}
												</FaRegHeart>
											</span>{" "}
											{props.show
												? translation(
														"components.menu.favorites"
												  )
												: ""}
										</Nav.Item>
									</Nav>
								</OverlayTrigger>
							</div>
						)}

						{/* Menu do usuário */}
						<OverlayTrigger
							placement={"right"}
							overlay={
								props.show ? (
									<></>
								) : (
									<Tooltip id={`tooltip-user`}>
										Usuário
									</Tooltip>
								)
							}
						>
							<Nav
								className="flex-column px-2 menu-item-user d-block"
								data-testid="showUserMenu"
								onClick={() =>
									props.showUserInfo
										? props.closeSubmenus()
										: props.setShowUserInfo(true)
								}
							>
								<Nav.Item
									className={`d-flex align-items-center text-truncate  ${
										props.showUserInfo ||
										window.location.pathname ===
											"/user-account"
											? "active-user"
											: "hoverMenu"
									}`}
									data-testid="showUserMenuItem"
								>
									<span
										className="d-flex mx-3 menu-icon"
										style={{ marginBottom: "10px" }}
									>
										<Avatar
											size="33"
											round={true}
											name={
												user.name !== ""
													? user.name
													: "U S"
											}
											src={user.picture ?? ""}
											color={
												!user.picture
													? colors.mainColors
															.blueberry
													: ""
											}
										/>
									</span>{" "}
									{props.show ? usernameFormatted : ""}
								</Nav.Item>
							</Nav>
						</OverlayTrigger>
					</>
				) : (
					<>
						{/* Itens para o usuário não autenticado */}
						<OverlayTrigger
							placement={"right"}
							overlay={
								props.show ? (
									<></>
								) : (
									<Tooltip id={`tooltip-favorites`}>
										{translation("components.menu.plans")}
									</Tooltip>
								)
							}
						>
							<Nav
								className="flex-column p-2 menu-item-plans"
								onClick={() => history.push("/plans")}
							>
								<Nav.Item
									className={`d-flex align-items-center hoverMenuPlans ${
										!props.show
											? "justify-content-center"
											: ""
									}`}
								>
									<span className="d-flex mx-3">
										<MdOutlineMonetizationOn
											style={{ fontSize: "27px" }}
										/>
									</span>{" "}
									{props.show
										? translation("components.menu.plans")
										: ""}
								</Nav.Item>
							</Nav>
						</OverlayTrigger>

						<OverlayTrigger
							placement={"right"}
							overlay={
								props.show ? (
									<></>
								) : (
									<Tooltip id={`tooltip-favorites`}>
										{translation(
											"components.menu.favorites"
										)}
									</Tooltip>
								)
							}
						>
							<Nav
								className="flex-column p-2 menu-item-favorites"
								data-testid="favoriteItemMenu"
								onClick={() => history.push("/favorites")}
							>
								<Nav.Item
									className={`d-flex align-items-center ${
										!props.show
											? "justify-content-center"
											: ""
									} ${
										window.location.pathname ===
										"/favorites"
											? "active-user"
											: "hoverMenu"
									}`}
								>
									<span className="d-flex mx-3">
										<FaRegHeart
											className="p-overlay-badge"
											style={{ fontSize: 23 }}
										>
											{!!notifications.quantity && (
												<Badge severity="success"></Badge>
											)}
										</FaRegHeart>
									</span>{" "}
									{props.show
										? translation(
												"components.menu.favorites"
										  )
										: ""}
								</Nav.Item>
							</Nav>
						</OverlayTrigger>

						<Nav
							className="flex-column p-2 menu-item-user"
							data-testid="showUserMenu"
							onClick={() =>
								props.showUserInfo
									? props.closeSubmenus()
									: props.setShowUserInfo(true)
							}
						>
							<Nav.Item
								className={`d-flex align-items-center ${
									!props.show ? "justify-content-center" : ""
								} ${
									props.showUserInfo ||
									window.location.pathname === "/user-account"
										? "active-user"
										: "hoverMenu"
								}`}
								data-testid="showUserMenuItem"
							>
								<span className="d-flex mx-3">
									<CgMenuGridR style={{ fontSize: "27px" }} />
								</span>{" "}
								{props.show ? "Menu" : ""}
							</Nav.Item>
						</Nav>
					</>
				)}
			</Navbar>
		</>
	);
};

const CollapsableListItem = (props: any) => {
	const { item, permissions, isActive, iconColor, show } = props;
	const history = useHistory();
	const [open, setOpen] = useState(false);
	const hasAccess = permissions[0].menus.includes(item.permission);
	const classes = isActive
		? `d-flex align-items-center hoverMenu menuActive ${item.classSelected}`
		: "d-flex align-items-center hoverMenu";

	const handleClick = () => {
		setOpen(!open);
		if (item.route !== "") {
			history.push(item.route);
		}
		if (item.link !== "") {
			window.location.href = item.link;
		}
	};

	useEffect(() => {
		let hasChildActive = item.children.find(
			(x: any) => x.route === window.location.pathname
		)
			? true
			: false;
		setOpen(hasChildActive);
	}, []);

	return (
		<>
			{hasAccess && (
				<OverlayTrigger
					placement={"right"}
					overlay={
						show ? (
							<></>
						) : (
							<Tooltip id={`tooltip-${item.name}`}>
								{item.name}
							</Tooltip>
						)
					}
				>
					<Nav className="flex-column p-2">
						<Nav.Item
							className={classes}
							onClick={handleClick}
							style={{
								cursor: "pointer",
								height: "6vh",
								borderRadius: "5px",
								fontFamily: "Lato",
							}}
							data-testid={`menuItem${item.name}`}
						>
							<span
								className="d-flex mx-3"
								style={{ color: iconColor, fontSize: "27px" }}
							>
								{item.icon}
							</span>{" "}
							{show ? item.name : ""}
							{item.children.length > 0 ? (
								<span className="d-flex justify-content-end w-100 mx-3">
									{open ? <FaChevronUp /> : <FaChevronDown />}
								</span>
							) : (
								""
							)}
						</Nav.Item>
						{item.children.map((_item: any, index: number) => {
							return _item.children.length > 0 ? (
								<Collapse
									key={index}
									in={open}
								>
									<CollapsableListItem
										item={_item}
										permissions={permissions}
									/>
								</Collapse>
							) : (
								<div key={index}>
									<InnerCollapsableItem
										item={_item}
										open={open}
										setOpen={setOpen}
										permissions={permissions}
										isActive={
											window.location.pathname ===
											_item.route
												? true
												: false
										}
									/>
								</div>
							);
						})}
					</Nav>
				</OverlayTrigger>
			)}
		</>
	);
};

const InnerCollapsableItem = (props: any) => {
	const history = useHistory();
	const { open, item, permissions, isActive, setOpen } = props;
	const hasAccess = permissions[0].subMenus.includes(item.permission);
	const classes = isActive
		? `flex-column p-2 hoverMenu menuActive ${item.classSelected}`
		: "flex-column p-2 hoverMenu";

	const navigate = () => {
		setOpen(true);
		history.push(item.route);
	};

	return (
		hasAccess && (
			<Collapse in={open}>
				<Nav className={classes}>
					<Nav.Item
						onClick={() => navigate()}
						style={{
							paddingLeft: item.level === 3 ? 55 : 35,
							cursor: "pointer",
							fontFamily: "Poppins, sans-serif",
							fontWeight: "normal",
						}}
					>
						{item.name}
					</Nav.Item>
				</Nav>
			</Collapse>
		)
	);
};
